import VideoTile from '@components/VideoTile';
import styled from '@emotion/styled';

export const Container = styled(VideoTile)`
  border: 1px solid #495057;
  border-radius: 4px;
  background-color: #161616;
`;
